export const dashboardTableStyles = {
  container: {
    height: 530,
  },

  loadingOverlayContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    height: "100%",
    width: "100%",
    padding: 4,
  },

  spinnerContainer: {
    mb: 2,
  },

  loadingText: {
    fontSize: "14px",
    fontWeight: 500,
    mb: 2,
  },

  progressBarContainer: {
    width: "60%",
    mt: 2,
  },

  progressInfoContainer: {
    display: "flex",
    justifyContent: "space-between",
    mb: 1,
  },

  getLoadingTextColor: (isComplete: boolean) => ({
    color: isComplete ? "success.main" : "text.secondary",
  }),

  getLoadingTextWeight: (isComplete: boolean) => ({
    fontWeight: isComplete ? 600 : 400,
  }),

  percentageText: {
    fontWeight: 600,
  },

  getLinearProgressStyles: (isComplete: boolean) => ({
    height: 8,
    borderRadius: 4,
    backgroundColor: "#e0e0e0",
    "& .MuiLinearProgress-bar": {
      borderRadius: 4,
      backgroundColor: isComplete ? "#4caf50" : "#1976d2",
    },
  }),

  preparingDataText: {
    mb: 1,
    textAlign: "center",
  },

  indeterminateProgressBar: {
    height: 8,
    borderRadius: 4,
    backgroundColor: "#e0e0e0",
    "& .MuiLinearProgress-bar": {
      borderRadius: 4,
      backgroundColor: "#1976d2",
    },
  },

  dataGrid: {
    border: "none",
  },

  paginationToolbar: {
    alignItems: "flex-start",
    justifyContent: "flex-start",
  },
};
